import { createContext, useContext, useState } from "react";

const ContactContext = createContext({ open: false, setOpen: () => {} });

export const ContactProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <ContactContext.Provider value={{ open, setOpen }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => useContext(ContactContext);
